var map = {
	"./icon-down.svg": 14,
	"./icon-facebook.svg": 15,
	"./icon-instagram.svg": 16,
	"./icon-twitter.svg": 17,
	"./icon-up.svg": 18,
	"./icon-youtube.svg": 19
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3;